"use client"

import { UnsupportBrowser } from '@/components/site/UnsupportBrowser';
import { useBrowserSupport } from '@/hooks/useBrowser';

export const BrowserDetect = ({ children }: React.PropsWithChildren) => {
  const isBrowserSupported = useBrowserSupport();
  if (!isBrowserSupported) {
    return <UnsupportBrowser />;
  }
  return children;
};